<template>
  <div>
    <!-- password change card -->
    <v-card rounded="0" :loading="loading">
      <div class="px-5 py-10">
        <!-- password change form -->
        <v-form ref="form" @submit.prevent="change" v-model="valid">
          <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({name: 'Login'})"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-card-title class="primary--text">Change password</v-card-title>
          </div>

          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0">
                <!-- new password textfield -->
                <v-text-field
                  v-model="password"
                  autofocus
                  label="New Password"
                  :disabled="loading"
                  :rules="[rules.required]"
                  hide-details
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- password strength meter -->
                <v-progress-linear
                  :value="meter.value"
                  :color="meter.color"
                  background-color="secondary"
                ></v-progress-linear>
              </v-col>

              <!-- password validation/error message -->
              <v-col
                cols="12"
                v-if="errors.length > 0"
              >
                <div
                  v-for="(error,key) in errors"
                  :key="key"
                  class="error-text"
                >
                  {{ error }}
                </div>
              </v-col>

              <v-col cols="12">
                <!-- confirm new password textfield -->
                <v-text-field
                  v-model="confirm"
                  autofocus
                  label="Confirm New Password"
                  :disabled="loading"
                  :rules="[rules.required, v => v==password || 'Password does not match']"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <!-- password change button -->
            <v-btn
              large
              rounded
              block
              color="primary"
              type="submit"
              :disabled="loading"
            >
              Change
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>

    <!-- error/success dialog -->
    <base-alert-dialog
      v-model="dialog.show"
      :message="dialog.message"
      @confirm="dialog.error ? dialog.show = false : $router.push({name: 'Login'})"
    ></base-alert-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ChangePassword',

    data: () => ({
      dialog: {
        show: false,
        message: '',
        error: false
      },
      meter: {
        value: '',
        color: ''
      },
      show1: false,
      show2: false,
      password: '',
      confirm: '',
      valid: false,
      loading: false,
      rules: {
        required: (v) => !!v || "This field is required",
        email: (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      },
      errors: [],
      password_rules: [
				{ message:'1 lowercase letter required', regex:/[a-z]+/ },
				{ message:"1 uppercase letter required",  regex:/[A-Z]+/ },
				{ message:"8 characters minimum", regex:/.{8,}/ },
				{ message:"1 number or 1 special character required", regex:/[0-9]+|[`!%$&^*()]+/ }
			],
    }),

    watch: {
      password(val) {
        if (val) {
          this.meter.value = '25'
          this.meter.color = 'red'

          // validate password
          var errors = []
          for (let condition of this.password_rules) {
            if (!condition.regex.test(val)) {
              errors.push(condition.message)
            }
          }
          
          switch (errors.length) {
            case 0:
              this.meter.value = '100'
              this.meter.color = 'green'
              break
            case 1:
              this.meter.value = '75'
              this.meter.color = 'yellow'
              break
            case 2:
              this.meter.value = '50'
              this.meter.color = 'orange'
              break
            case 4:
              this.meter.value = '25'
              this.meter.color = 'red'
              break
            default:
              break
          }

          this.errors = errors
        }
        else {
          this.meter.value = '0'
        }
      }
    },

    computed: {
      email() { return this.$route.query.email },
      code() { return this.$route.query.password_reset_code },
    },

    methods: {
			async change() {
        this.$refs.form.validate()

        if (this.valid && this.errors.length < 1) {
          try {
            this.loading = true
            const data = {
              code: this.code,
              email: this.email,
              pass: this.password,
              pass_confirm: this.confirm
            }
            var response = await this.$store.dispatch("password/change", data);
            console.log('[change/response]', response, data)
            this.loading = false;
            if (response.status == 200) {
              // show success popup
              this.dialog.error = false
              this.dialog.show = true
              this.dialog.message = "Password changed. You may now login with your new password."
            }
          }
          catch (e) {
            console.log('[error]', e)
            // show error popup
            this.dialog.error = true
            this.dialog.show = true
            this.dialog.message = "Sorry, your request cannot be processed. Please try again."
          }
        }
      }
		}
  }
</script>

<style lang="scss" scoped>

</style>